import type {ApplicationServices} from '../types/services'
import {createContext, useContext} from 'react'

export const ApplicationServicesContext = createContext<ApplicationServices | null>(null)

export const useApplicationServices = () => {
  const services = useContext(ApplicationServicesContext)
  if (!services) throw new Error('ApplicationServicesContext requires application services.')
  return services
}
